/**
 * Rozdělení promo obrázků podle toho, kam v letáku patří.
 *
 * Filtruje se podle použití, ne podle přesné velikosti — hlavička má dvě
 * varianty (2×1 a 2×2) a „promo" je všechno ostatní. Používá se na dvou
 * místech (paleta v editoru letáku a správa promo obrázků), proto sdíleně.
 */
export type PromoSkupina = 'hlavicka' | 'promo' | 'paticka';
export type PromoFiltr = 'vse' | PromoSkupina;

export const PROMO_FILTRY: { key: PromoFiltr; label: string }[] = [
  { key: 'vse', label: 'Vše' },
  { key: 'hlavicka', label: 'Hlavičky' },
  { key: 'promo', label: 'Promo' },
  { key: 'paticka', label: 'Patičky' },
];

export const promoSkupina = (defaultSize?: string): PromoSkupina => {
  if (defaultSize === 'footer') return 'paticka';
  if (defaultSize === 'header_2x1' || defaultSize === 'header_2x2') return 'hlavicka';
  return 'promo';
};

/** Projde obrázek zvoleným filtrem? `vse` propustí všechno. */
export const sedneNaFiltr = (defaultSize: string | undefined, filtr: PromoFiltr): boolean =>
  filtr === 'vse' || filtr === promoSkupina(defaultSize);
